import Component from '@glimmer/component';

import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';

export default class ColorPicker extends Component {
  get backgroundColorStyle() {
    return sanitizeHtml(`background-color: ${this.args.option}`);
  }
}
